module.exports = __webpack_public_path__ + "static/media/teaCoffee.6bc5b648.webp";